import React, { Component } from 'react';
import PropTypes from 'prop-types';

class FormSkeleton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitTries: 0,
      validateForm: false,
      validationTries: 0,
    };
    this.activeFormElements = 0;
    this.validatedElements = 0;
    this.validElements = 0;
  }

  onSubmit = (event) => {
    event.preventDefault();
    let { submitTries } = this.state;
    this.validElements = 0;
    this.validatedElements = 0;
    submitTries += 1;
    this.setState({
      submitTries,
      validateForm: false,
    });
    return false;
  };

  validateFormElement = (validatedObj) => {
    this.validatedElements += 1;
    if (validatedObj.validated && !validatedObj.errorMsg) {
      this.validElements += 1;
    }
    if (this.validatedElements === this.activeFormElements) {
      let { validationTries } = this.state;
      validationTries += 1;
      if (this.validatedElements === this.validElements) {
        this.setState({
          validateForm: true,
          validationTries,
        });
      } else {
        this.setState({
          validateForm: false,
          validationTries,
        });
      }
    }
  };

  activateFormElement = () => {
    this.activeFormElements += 1;
  };

  deactivateFormElement = () => {
    this.activeFormElements -= 1;
  };

  render() {
    const {
      autocomplete, name, wrapperClass, id, children,
    } = this.props;

    const { submitTries, validationTries } = this.state;

    const childrenWithProps = React.Children.map(children, (child) => {
      const { validateForm } = this.state;
      return React.cloneElement(child, {
        formSkeletonProps: {
          submitTries,
          validationTries,
          activateFormElement: this.activateFormElement,
          deactivateFormElement: this.deactivateFormElement,
          validateFormElement: this.validateFormElement,
          validateForm,
        },
      });
    });

    return (
      <form
        autoComplete={autocomplete}
        name={name}
        className={`formSkeleton ${wrapperClass}`}
        id={id}
        onSubmit={this.onSubmit}
      >
        {childrenWithProps}
      </form>
    );
  }
}

FormSkeleton.propTypes = {
  autocomplete: PropTypes.string,
  name: PropTypes.string.isRequired,
  wrapperClass: PropTypes.string,
  id: PropTypes.string,
  children: PropTypes.node.isRequired,
};

FormSkeleton.defaultProps = {
  autocomplete: 'false',
  wrapperClass: '',
  id: 'rfs',
};

export default FormSkeleton;
